/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { CheckResetTokenOptions, CheckResetTokenResponses } from '../../models/CheckResetToken'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Check Reset Token
 * {@link /check-reset-token}
 */
export function checkResetToken<ThrowOnError extends boolean = true>(options: Options<CheckResetTokenOptions, ThrowOnError> = {}): Promise<UnwrappedResult<CheckResetTokenResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/check-reset-token', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<CheckResetTokenResponses, ThrowOnError>>
}
